var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 214,
    viewBox: "0 0 101 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4421 34.1495C54.1271 55.1912 37.567 69.1249 37.567 69.1249C37.567 69.1249 17.322 62.017 13.637 40.9754C9.95203 19.9337 26.5121 6 26.5121 6C26.5121 6 46.7571 13.108 50.4421 34.1495Z",
    stroke: "#E3DBEB",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8268 127.057C63.8478 141.312 43.0766 133.375 43.0766 133.375C43.0766 133.375 39.2846 111.183 56.2637 96.9284C73.2429 82.6736 94.014 90.6109 94.014 90.6109C94.014 90.6109 97.8059 112.802 80.8268 127.057Z",
    stroke: "#E3DBEB",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8859 205.806C8.94839 198.539 6.00059 178.162 6.00059 178.162C6.00059 178.162 21.9902 165.052 40.9277 172.319C59.8652 179.586 62.813 199.963 62.813 199.963C62.813 199.963 46.8233 213.073 27.8859 205.806Z",
    stroke: "#E3DBEB",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 178.162C23.7394 163.002 43.8818 132.962 43.8818 103.557C43.8818 91.3803 41.9265 79.7579 38.3756 69.125",
    stroke: "#E3DBEB",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFlower);
export default __webpack_public_path__ + "static/media/rightFlower.dcf7c91acec2146010428331beb89698.svg";
export { ForwardRef as ReactComponent };